import { Injectable } from '@angular/core';
import { ReplaySubject } from 'rxjs';

@Injectable()
export class GreetingService {
  private readonly currentBalance$: ReplaySubject<number> = new ReplaySubject();
  private readonly balanceAsOfDateTime$: ReplaySubject<string> = new ReplaySubject();

  public setCurrentBalance(balance: number): void {
    this.currentBalance$.next(balance);
    document.querySelector('greetings-widget')?.setAttribute('current-balance', balance.toString());
  }

  public setBalanceAsOfDateTime(balanceAsOfDateTime: string): void {
    this.balanceAsOfDateTime$.next(balanceAsOfDateTime);
    document
      .querySelector('greetings-widget')
      ?.setAttribute('value-as-of-date', balanceAsOfDateTime.toString());
  }
}
